import React from "react";
import { FormGroup, ControlLabel, HelpBlock } from "react-bootstrap";
import { Control, getField, Errors } from 'react-redux-form';
class TextBox extends React.Component {
    onChange() {
        const { onChangeCallback } = this.props;
        if (onChangeCallback) {
            onChangeCallback(this.input.value);
        }
    }
    getValidationState() {
        const field = getField(this.props.form, this.props.model);
        if (field.touched) {
            if (!field.valid) {
                return "error";
            }
        }
        return null;
    }
    renderInput() {
        let { form, type, placeHolderText, valueFormatter, model, validateOn, validators } = this.props;
        if (type === "textarea") {
            return (React.createElement(Control.textarea, { model: model, getRef: (input) => this.input = input, className: "form-control", placeholder: placeHolderText, validateOn: validateOn, validators: validators, onChange: () => this.onChange() })
            //<textarea className="form-control"
            //          placeholder={placeHolderText}
            //          onInput = {(a) => {
            //          if (_global_isIe11) {
            //                  this.props.dispatch(actions.reset(formPath));
            //                  this.props.dispatch(actions.change(formPath, a.target.value, { silent: false }));
            //                  a.preventDefault();
            //              }
            //          }}
            //          onChange={(a) => this.onChange(a)}
            //          onBlur={(a) => this.onChange(a) }
            //          value={valueFormatter && valueFormatter(field.value) }/>
            );
        }
        else {
            return (React.createElement(Control.text, { model: model, getRef: (input) => this.input = input, className: "form-control", placeholder: placeHolderText, type: type, validateOn: validateOn, validators: validators, onChange: () => this.onChange() }));
        }
    }
    render() {
        const { labelText, model } = this.props;
        const validationState = this.getValidationState();
        return (React.createElement(FormGroup, { validationState: validationState },
            React.createElement(ControlLabel, null, labelText),
            this.renderInput(),
            React.createElement(Errors, { model: model, show: "touched", messages: Object.assign({}, this.props.errors), component: (props) => React.createElement(HelpBlock, null, props.children) })));
    }
}
TextBox.defaultProps = {
    type: "text",
    validateOn: "change",
};
export { TextBox };
